import dayjs from 'dayjs';

import type { Dayjs } from 'dayjs';

export const formatIsoToDisplay = (date?: string) => dayjs(date).format('DD-MM-YYYY HH:mm');

export const formatDayjsToDataDTO = (value: Dayjs) => value.toISOString();

export const getDayjs = (date: string) => dayjs(date);
